import { render } from "./px-money.vue?vue&type=template&id=39107684&scoped=true&ts=true"
import script from "./px-money.vue?vue&type=script&lang=ts"
export * from "./px-money.vue?vue&type=script&lang=ts"

import "./px-money.vue?vue&type=style&index=0&id=39107684&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39107684"]])

export default __exports__